import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import {
  IconButton,
  Paper,
  TableContainer,
  Tooltip
} from "@mui/material";
import { MaterialReactTable, useMaterialReactTable } from "material-react-table";
import { useMemo, useState } from "react";
import { tableConfig } from "../../../../commons/table/tableConfig";
import { StyledClausula, StyledEmpresaTable } from "../../../../styled/Personal";
import EmpleadorForm from "./EmpresaForm";

const EmpresaTable = ({
  empresaList,
  openAddEmpresa,
  edit,
  empresa,
  handleAddEmpresa,
  handleCloseEmpresa,
  addEmpresa,
  deleteEmpresa,
  editEmpresa,
}) => {

  const columns = useMemo(() => [
    {
      accessorKey: 'cuit',
      header: 'CUIT',
      size: 150,
    },
    {
      accessorKey: 'razonsocial',
      header: 'Razón Social',
      size: 200,
    },
  ], []);

  const [rowsPerPage, setRowsPerPage] = useState(5);

  const table = useMaterialReactTable({
    ...tableConfig,
    columns,
    data: empresaList,
    enableRowSelection: false,
    enablePagination: true,
    initialState: {
      ...tableConfig.initialState,
      pagination: {
        pageIndex: 0,
        pageSize: rowsPerPage ?? 5,
      }
    },
    paginationDisplayMode: 'pages',
    positionPagination: 'bottom',
    muiPaginationProps: {
      rowsPerPageOptions: [5, 10, 25],
      labelRowsPerPage: 'Filas por página:',
    },
    // Hide toolbar buttons
    renderTopToolbar: false,
    enableColumnFilters: false,        // Hide filter buttons 
    enableFilters: false,              // Disable all filtering
    enableDensityToggle: false,        // Hide density toggle
    enableFullScreenToggle: false,     // Hide full screen toggle
    enableColumnActions: false,        // Hide column actions (menu)
    enableHiding: false,               // Disable column hiding
    enableRowActions: true,
    enableColumnOrdering: false,
    renderRowActions: ({ row }) => (
      <StyledEmpresaTable.Icons>
        <Tooltip title="Editar" placement="bottom" arrow>
          <IconButton onClick={() => editEmpresa(row.original)}>
            <EditIcon />
          </IconButton>
        </Tooltip>
        <Tooltip title="Eliminar" placement="bottom" arrow>
          <IconButton onClick={() => deleteEmpresa(row.original)}>
            <DeleteIcon />
          </IconButton>
        </Tooltip>
      </StyledEmpresaTable.Icons>
    ),
    renderBottomToolbarCustomActions: () => (
      <StyledClausula.Button
        size="small"
        color="primary"
        variant="contained"
        onClick={addEmpresa}
      >
        Agregar empresa
      </StyledClausula.Button>
    ),
  });

  return (
    <>
      <TableContainer component={Paper}>
        <MaterialReactTable table={table} />
      </TableContainer>
      <EmpleadorForm
        open={openAddEmpresa}
        edit={edit}
        empresa={empresa}
        handleSubmit={handleAddEmpresa}
        handleClose={handleCloseEmpresa}
      />
    </>
  );
};

export default EmpresaTable;